import React from 'react'

class BenefitSearch extends React.Component {
   constructor(props) {
      super(props)
      this.state =  {show_reset_button: false}
    }

    componentDidMount() {
      return this._subscribeToEvents();
    }

    componentWillUnmount() {
      return this._unsubscribeFromEvents();
    }

    _subscribeToEvents() {
      return PubSub.subscribe('clearInput:onClick', () => {
        return this.refs.search.value = '';
      });
    }

    _unsubscribeFromEvents() {
      return PubSub.unsubscribe('clearInput:onClick');
    }

    handleSubmit(e){
      e.preventDefault();
      return $.ajax({
        url: '/leave_plan_benefits',
        method: 'GET',
        dataType: 'JSON',
        data: { q: this.refs.search.value },
        success: filtered_benefits => {
          return this.props.handleOnSubmit(filtered_benefits);
        }
      });
    }

    handleOnChange() {
      if (this.refs.search.value) {
        return this.setState({show_reset_button: true});
      } else {
        this.setState({show_reset_button: false});
        return this.props.handleOnReset();
      }
    }

    handleOnReset(e) {
      e.preventDefault();
      this.refs.search.value = '';
      this.setState({show_reset_button: false});
      return this.props.handleOnReset();
    }

    render() {
      return ( 
        <form className='search-box' onSubmit={this.handleSubmit.bind(this)}>
          <input type='search' ref='search' className='form-control input-bdr-rds' onChange={this.handleOnChange.bind(this)} placeholder='Search benefits'/>
          {this.state.show_reset_button && <button onClick={this.handleOnReset.bind(this)} className='close-icon' type='reset'/>}
        </form>
       );
    }
}

export default BenefitSearch

